import React, { useEffect, useState } from "react";
import {
  query,
  orderBy,
  collection,
  limit,
  getDocs,
  getFirestore,
  where,
} from "firebase/firestore";
import Datepicker from "react-tailwindcss-datepicker";
import Chart from "react-apexcharts";
import { db } from "../App";

const WeatherModal = () => {
  const [weatherData, setWeatherData] = useState();
  const [tempData, setTempData] = useState({
    name: "Temperature",
    data: [],
    color: "darkBlue",
  });
  const [feelsLikeData, setFeelsLikeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = React.useState(false);

  const tonight = new Date();
  tonight.setHours(23, 59, 0, 0);
  const thisMorning = new Date();
  thisMorning.setHours(0, 0, 0, 0);

  const [value, setValue] = useState({
    startDate: thisMorning,
    endDate: tonight,
  });

  //const tempMinMax =
  const tempOptions = ["dewPoint, feelsLike, tempf"];
  const dataPoints = [
    "dewPoint, feelsLike, humidity, maxdailygust, solarradiation, tempf, uv, winddir, windspeed, windgust",
  ];
  const rainData = ["hourlyrain, dailyrain, monthlyrain, yearlyrain"];

  const findLocalExtrema = (n, arr) => {
    const localMinimums = [];
    const localMaximums = [];

    const minMaxTemps = [];
    console.log(arr);
    // Iterate over the array, skipping the first and last element
    // Empty vector to store points of
    // local maxima and minima
    let temps = [];

    // Checking whether the first point is
    // local maxima or minima or none
    if (arr[0] > arr[1]) temps.push(arr[0]);
    else if (arr[0] < arr[1]) temps.push(arr[0]);

    // Iterating over all points to check
    // local maxima and local minima
    for (let i = 1; i < n - 1; i++) {
      // Condition for local minima
      if (arr[i - 1] > arr[i] && arr[i] < arr[i + 1]) temps.push(arr[i]);
      // Condition for local maxima
      else if (arr[i - 1] < arr[i] && arr[i] > arr[i + 1]) temps.push(arr[i]);
    }

    // Checking whether the last point is
    // local maxima or minima or none
    if (arr[n - 1] > arr[n - 2]) temps.push(arr[n - 1]);
    else if (arr[n - 1] < arr[n - 2]) temps.push(arr[n - 1]);

    console.log (temps)
    setTempData({
      name: "Temperature",
      data: temps,
      color: "#87C9ED",
    });
  };

  // Example u

  const handleValueChange = (newValue) => {
    console.log("newValue:", newValue);
    const startDate = new Date(newValue.startDate).setHours(0, 0, 0, 0);
    const endDate = new Date(newValue.endDate).setHours(23, 59, 0, 0);
    setValue({
      startDate: startDate,
      endDate: endDate,
    });
  };

  const getWeatherData = async () => {
    setIsLoading(true);
    const weatherRef = collection(db, "weatherData");

    console.log(value);
    const q = query(
      weatherRef,
      orderBy("dateutc", "desc"),
      where("dateutc", ">", new Date(value.startDate).getTime()),
      where("dateutc", "<", new Date(value.endDate).getTime())
    );

    const querySnapshot = await getDocs(q);
    const fetchedData = [];
    const fetchedTemps = [];

    const fetchedFeelsLike = [];
    const fetchedDewPoint = [];

    const lastTemp = 0;

    querySnapshot.forEach((doc) => {
      const reading = doc.data();
      fetchedData.push(reading);
      //if (reading.tempf !== lastTemp) {
      fetchedTemps.push(reading.tempf);
      //fetchedFeelsLike.push(reading.tempf);
      //fetchedDewPoint.push(reading.tempf);
      //}
    });
    findLocalExtrema(fetchedTemps.length, fetchedTemps);
    setWeatherData(fetchedData);

    setIsLoading(false);
  };

  useEffect(() => {
    getWeatherData();
  }, [value]);

  const options = {
    chart: {
      height: "100%",
      maxWidth: "100%",
      type: "line",
      fontFamily: "Inter, sans-serif",
      dropShadow: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      enabled: true,
      x: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 6,
    },
    grid: {
      show: true,
      strokeDashArray: 4,
      padding: {
        left: 2,
        right: 2,
        top: -26,
      },
    },
    series: [
      {
        name: "Clicks",
        data: [6500, 6418, 6456, 6526, 6356, 6456],
        color: "#1A56DB",
      },
      {
        name: "CPC",
        data: [6456, 6356, 6526, 6332, 6418, 6500],
        color: "#7E3AF2",
      },
    ],
    legend: {
      show: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      categories: ["1", "2", "3"],

      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: true,
    },
  };

  return (
    <>
      <button
        className="bg-white text-mediumBlue border-blueGray-200  active:bg-darkBlue font-bold uppercase text-sm px-2 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
        type="button"
        onClick={() => setShowModal(true)}
      >
        <div className="flex items-center gap-2 justify-center text-sm">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
        </div>
      </button>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto text-darkBlue fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-8/12 my-6 mx-auto">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200  rounded-t">
                  <h3 className="text-3xl font-semibold">
                    Historical Conditions
                  </h3>
                </div>
                {/*body*/}

                <div className="flex justify-end p-4">
                  <div className="w-1/2 block">
                    <Datepicker
                      primaryColor="blue"
                      showShortcuts={true}
                      showFooter={true}
                      inputClassName="focus:border-darkBlue text-darkBlue h-max w-full rounded-lg border text-gray-900 focus:border focus:outline-none disabled:border-gray-200 disabled:text-gray-400 dark:text-white dark:disabled:text-gray-500"
                      value={value}
                      onChange={handleValueChange}
                    />
                  </div>
                </div>
                <div className="xs:w-screen md:min-w-[600px] md:min-h-96 w-full h-full flex justify-center items-center">
                  {isLoading ? (
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                      <span class="sr-only">Loading...</span>
                    </div>
                  ) : (
                    <div class="w-full bg-white dark:bg-gray-800 p-4 md:p-6 h-full ">
                      <Chart
                        options={options}
                        series={[tempData]}
                        type="line"
                      />
                    </div>
                  )}
                </div>
              </div>
              {/*footer*/}
              <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                <button
                  className="text-darkBlue background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>

          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default WeatherModal;
